import * as types from '../actionTypes';
import { getCommonData } from '../../api';
import commonData from '../../mock/layout.json'

export function dispatchCommonData(value) {
  const params = {
    functionId: 'queryChannelData',
    appid: 'jdw_pc',
    client: 'pc',
    body: value
  }
  const config = { isSigned: true }
  return async (dispatch) => {
    let value = commonData;
    try {
      const res = await getCommonData(params, config);
      if (res?.code == 0 && res?.result?.data) {
        value = res.result
      }
    } catch (error) {
      
    } finally {
      dispatch({
        type: types.COMMON_DATA,
        value
      })
    }
  }
}